import React from 'react';
import { Row, Col, Card, Button, Typography, Space, Image } from 'antd';
import { 
  DollarCircleOutlined, 
  ClockCircleOutlined, 
  SafetyOutlined, 
  UserOutlined,
  CheckCircleOutlined,
  PhoneOutlined,
  AppleOutlined,
  AndroidOutlined
} from '@ant-design/icons';
import { Link } from 'react-router-dom';

const { Title, Paragraph } = Typography;

const Home: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}
      <div className="hero-section">
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <div className="hero-content">
            <Title level={1} style={{ color: 'white', marginBottom: '20px' }}>
              Welcome to JEJELY ULTIMATE LIMITED
            </Title>
            <Paragraph style={{ color: 'white', fontSize: '1.2rem', marginBottom: '30px' }}>
              Your trusted partner for personal microfinance solutions in Nigeria. 
              Fast, reliable, and secure loans tailored to your needs.
            </Paragraph>
            <Space size="large">
              <Button type="primary" size="large" href="#features">
                Learn More
              </Button>
              <Button size="large" style={{ background: 'rgba(255,255,255,0.2)', color: 'white', border: '1px solid rgba(255,255,255,0.3)' }}>
                <Link to="/contact" style={{ color: 'white' }}>Contact Us</Link>
              </Button>
            </Space>
          </div>
        </div>
      </div>

      {/* Our Product Section */}
      <div style={{ padding: '60px 0', background: '#f8f9fa' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <Title level={2}>Our Product</Title>
            <Paragraph style={{ fontSize: '1.1rem', color: '#666', marginBottom: '40px' }}>
              Experience the future of digital lending with our flagship mobile application
            </Paragraph>
          </div>
          
          <Row gutter={[40, 40]} justify="center" align="middle">
            <Col xs={24} lg={12}>
              <div style={{ textAlign: 'center' }}>
                <div style={{ marginBottom: '20px' }}>
                  <Image
                    src="/images/FairLoner logo.jpg"
                    alt="Fairloner Logo"
                    style={{ 
                      width: '80px', 
                      height: '80px'
                    }}
                    preview={false}
                  />
                </div>
                <Title level={3} style={{ color: '#1890ff', marginBottom: '20px' }}>
                  Fairloner: Safe & Instant Loan
                </Title>
                <Paragraph style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '30px' }}>
                  Our flagship mobile application that revolutionizes the way you access personal loans. 
                  Built with cutting-edge technology and designed for the modern Nigerian consumer.
                </Paragraph>
                
                <div
                  style={{
                    marginBottom: '30px',
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'nowrap',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 14,
                    width: '100%',
                    overflowX: 'auto',
                    WebkitOverflowScrolling: 'touch',
                  }}
                >
                  <Button
                    type="primary"
                    size="large"
                    href="https://apps.apple.com/ng/app/fairloner-safe-instant-loan/id6749295692"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      flex: '1 1 0',
                      minWidth: 0,
                      maxWidth: 280,
                      background: 'linear-gradient(180deg, #2c2c2e 0%, #000 100%)',
                      border: '1px solid rgba(255,255,255,0.12)',
                      height: 52,
                      padding: '0 18px',
                      fontSize: '1rem',
                      fontWeight: 600,
                      borderRadius: 12,
                      boxShadow: '0 4px 14px rgba(0,0,0,0.18)',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <AppleOutlined style={{ fontSize: '1.35rem', marginRight: 8 }} />
                    Download on App Store
                  </Button>
                  <Button
                    type="primary"
                    size="large"
                    href="https://play.google.com/store/apps/details?id=ng.loan.fairloner"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      flex: '1 1 0',
                      minWidth: 0,
                      maxWidth: 280,
                      background: 'linear-gradient(180deg, #00c853 0%, #01875f 100%)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      height: 52,
                      padding: '0 18px',
                      fontSize: '1rem',
                      fontWeight: 600,
                      borderRadius: 12,
                      boxShadow: '0 4px 14px rgba(1,135,95,0.35)',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <AndroidOutlined style={{ fontSize: '1.35rem', marginRight: 8 }} />
                    Download on Google Play
                  </Button>
                </div>
              </div>
            </Col>
            
            <Col xs={24} lg={12}>
              <div className="app-features-box" style={{ background: 'white', padding: '40px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                <Title level={4} style={{ color: '#1890ff', marginBottom: '25px', textAlign: 'center' }}>App Features</Title>
                <Row gutter={[20, 20]}>
                  <Col xs={24} sm={12}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                      <CheckCircleOutlined style={{ color: '#52c41a', marginRight: '8px', fontSize: '1.2rem' }} />
                      <span>Fast loan applications</span>
                    </div>
                  </Col>
                  <Col xs={24} sm={12}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                      <CheckCircleOutlined style={{ color: '#52c41a', marginRight: '8px', fontSize: '1.2rem' }} />
                      <span>Real-time updates</span>
                    </div>
                  </Col>
                  <Col xs={24} sm={12}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                      <CheckCircleOutlined style={{ color: '#52c41a', marginRight: '8px', fontSize: '1.2rem' }} />
                      <span>Secure payments</span>
                    </div>
                  </Col>
                  <Col xs={24} sm={12}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                      <CheckCircleOutlined style={{ color: '#52c41a', marginRight: '8px', fontSize: '1.2rem' }} />
                      <span>24/7 support</span>
                    </div>
                  </Col>
                  <Col xs={24} sm={12}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                      <CheckCircleOutlined style={{ color: '#52c41a', marginRight: '8px', fontSize: '1.2rem' }} />
                      <span>High loan amounts</span>
                    </div>
                  </Col>
                  <Col xs={24} sm={12}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                      <CheckCircleOutlined style={{ color: '#52c41a', marginRight: '8px', fontSize: '1.2rem' }} />
                      <span>Low interest rates</span>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      {/* Features Section */}
      <div id="features" className="features-section">
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <Title level={2}>Why Choose Fairloner?</Title>
            <Paragraph style={{ fontSize: '1.1rem', color: '#666' }}>
              We provide comprehensive microfinance solutions with a focus on customer satisfaction and financial inclusion.
            </Paragraph>
          </div>
          
          <Row gutter={[30, 30]}>
            <Col xs={24} sm={12} lg={6}>
              <Card className="feature-card">
                <div className="feature-icon">
                  <DollarCircleOutlined />
                </div>
                <Title level={4}>Quick Loans</Title>
                <Paragraph>
                  Fast approval process with minimal documentation. Get the funds you need when you need them.
                </Paragraph>
              </Card>
            </Col>
            
            <Col xs={24} sm={12} lg={6}>
              <Card className="feature-card">
                <div className="feature-icon">
                  <ClockCircleOutlined />
                </div>
                <Title level={4}>24/7 Service</Title>
                <Paragraph>
                  Round-the-clock customer support to assist you with all your financial needs and inquiries.
                </Paragraph>
              </Card>
            </Col>
            
            <Col xs={24} sm={12} lg={6}>
              <Card className="feature-card">
                <div className="feature-icon">
                  <SafetyOutlined />
                </div>
                <Title level={4}>Secure & Licensed</Title>
                <Paragraph>
                  Fully licensed microfinance institution with secure and transparent lending practices.
                </Paragraph>
              </Card>
            </Col>
            
            <Col xs={24} sm={12} lg={6}>
              <Card className="feature-card">
                <div className="feature-icon">
                  <UserOutlined />
                </div>
                <Title level={4}>Personalized Service</Title>
                <Paragraph>
                  Tailored loan solutions designed to meet your specific financial requirements and goals.
                </Paragraph>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      {/* Services Section */}
      <div style={{ padding: '60px 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <Title level={2}>Our Services</Title>
            <Paragraph style={{ fontSize: '1.1rem', color: '#666' }}>
              Personal loan solutions designed to meet your financial needs
            </Paragraph>
          </div>
          
          <Row gutter={[30, 30]} justify="center">
            <Col xs={24} lg={16}>
              <Card style={{ height: '100%', textAlign: 'center' }}>
                <Title level={3} style={{ color: '#1890ff' }}>Personal Loans</Title>
                <Paragraph style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
                  Flexible personal loans for various purposes including education, medical expenses,
                  home improvements, and personal emergencies.
                </Paragraph>
                <Row gutter={[20, 20]} style={{ marginTop: '30px' }}>
                  <Col xs={24} sm={12}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <CheckCircleOutlined style={{ color: '#52c41a', marginRight: '8px', fontSize: '1.2rem' }} />
                      <span>Loan amounts from ₦2,000 to ₦300,000</span>
                    </div>
                  </Col>
                  <Col xs={24} sm={12}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <CheckCircleOutlined style={{ color: '#52c41a', marginRight: '8px', fontSize: '1.2rem' }} />
                      <span>Competitive interest rates</span>
                    </div>
                  </Col>
                  <Col xs={24} sm={12}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <CheckCircleOutlined style={{ color: '#52c41a', marginRight: '8px', fontSize: '1.2rem' }} />
                      <span>Flexible repayment terms</span>
                    </div>
                  </Col>
                  <Col xs={24} sm={12}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <CheckCircleOutlined style={{ color: '#52c41a', marginRight: '8px', fontSize: '1.2rem' }} />
                      <span>Quick approval process</span>
                    </div>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      {/* Benefits Section */}
      <div style={{ background: '#f8f9fa', padding: '60px 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <Title level={2}>Benefits of Choosing Us</Title>
          </div>
          
          <Row gutter={[30, 30]}>
            <Col xs={24} sm={8}>
              <div style={{ textAlign: 'center' }}>
                <CheckCircleOutlined style={{ fontSize: '3rem', color: '#52c41a', marginBottom: '20px' }} />
                <Title level={4}>No Hidden Fees</Title>
                <Paragraph>
                  Transparent pricing with no hidden charges or surprise fees.
                </Paragraph>
              </div>
            </Col>
            
            <Col xs={24} sm={8}>
              <div style={{ textAlign: 'center' }}>
                <CheckCircleOutlined style={{ fontSize: '3rem', color: '#52c41a', marginBottom: '20px' }} />
                <Title level={4}>Flexible Terms</Title>
                <Paragraph>
                  Customizable repayment schedules that fit your financial situation.
                </Paragraph>
              </div>
            </Col>
            
            <Col xs={24} sm={8}>
              <div style={{ textAlign: 'center' }}>
                <CheckCircleOutlined style={{ fontSize: '3rem', color: '#52c41a', marginBottom: '20px' }} />
                <Title level={4}>Local Expertise</Title>
                <Paragraph>
                  Deep understanding of the Nigerian market and local business needs.
                </Paragraph>
              </div>
            </Col>
          </Row>
        </div>
      </div>


      {/* CTA Section */}
      <div className="cta-section">
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px', textAlign: 'center' }}>
          <div className="cta-content">
            <Title level={2} style={{ color: 'white' }}>
              Ready to Get Started?
            </Title>
            <Paragraph style={{ color: 'white', fontSize: '1.1rem', marginBottom: '30px' }}>
              Contact us today to learn more about our loan products and how we can help you achieve your financial goals.
            </Paragraph>
            <Space size="large" wrap>
              <Button type="primary" size="large" style={{ background: 'white', color: '#1890ff', border: 'none' }}>
                <Link to="/contact">Get in Touch</Link>
              </Button>
              <Button 
                size="large" 
                style={{ background: 'rgba(255,255,255,0.2)', color: 'white', border: '1px solid rgba(255,255,255,0.3)' }}
                href="https://apps.apple.com/ng/app/fairloner-safe-instant-loan/id6749295692"
                target="_blank"
                rel="noopener noreferrer"
              >
                <AppleOutlined /> Download App
              </Button>
              <Button size="large" style={{ background: 'rgba(255,255,255,0.2)', color: 'white', border: '1px solid rgba(255,255,255,0.3)' }}>
                <PhoneOutlined /> 08158120510
              </Button>
            </Space>
          </div>
        </div>
      </div>

      {/* Contact Info Section */}
      {/* <div style={{ padding: '60px 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <Row gutter={[30, 30]}>
            <Col xs={24} md={12}>
              <div className="contact-info">
                <Title level={3}>Contact Information</Title>
                <div className="contact-item">
                  <PhoneOutlined />
                  <span>Phone: 08158120510</span>
                </div>
                <div className="contact-item">
                  <MailOutlined />
                  <span>Email: fairlonerhelp@gmail.com</span>
                </div>
                <div className="contact-item">
                  <SafetyOutlined />
                  <span>Licensed Microfinance Institution</span>
                </div>
              </div>
            </Col>
            
            <Col xs={24} md={12}>
              <div className="contact-info">
                <Title level={3}>Business Hours</Title>
                <Paragraph>
                  <strong>Monday - Friday:</strong> 8:00 AM - 6:00 PM<br />
                  <strong>Saturday:</strong> 9:00 AM - 4:00 PM<br />
                  <strong>Sunday:</strong> Closed
                </Paragraph>
                <Paragraph>
                  <em>Emergency support available 24/7 for existing customers</em>
                </Paragraph>
              </div>
            </Col>
          </Row>
        </div>
      </div> */}
    </div>
  );
};

export default Home;
